import {combineReducers} from 'redux'
import authReducer from './authReducer'
import navbarReducer from './navbarReducer'
import asyncReducer from './asyncReducer'
import modalReducer from './modalReducer'
import dataReducer from './dataReducer'



const rootReducer = combineReducers({
  auth: authReducer,
  navbar: navbarReducer,
  async: asyncReducer,
  modal: modalReducer,
  data: dataReducer

})

export default rootReducer
